import {
  Stack,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useState } from "react";
import { getNotes } from "../../api"
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import AddNoteModal from "../modals/AddNoteModal";
import NoteCard from "../cards/NoteCard";
import ListData from "../common/ListData"

const NotesTab = ({ batchId }) => {
  const [search, setSearch] = useState("");
  const [addModal, setAddModal] = useState(false);
  const handleSearchChange = (event) => setSearch(event.target.value);
  const openAddModal = () => setAddModal(true);
  const closeAddModal = () => setAddModal(false);
  const CTA = () => (
    <Stack direction="row" justifyContent="space-between">
        <TextField
          value={search}
          onChange={handleSearchChange}
          placeholder="Search Notes..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={openAddModal}
          variant="contained"
          startIcon={<AddRoundedIcon />}
        >
          Add Note
        </Button>
      </Stack>
  )
  return (
    <>
    <ListData
      getAllData={getNotes}
      initialFilters={batchId && { filter: { batchId: batchId } }}
      HeaderFull={CTA}
      Card={NoteCard}
      type="CARD"
      noView
      noFilterSort
    />
      <AddNoteModal isOpen={addModal} close={closeAddModal} />
    </>
  );
};

export default NotesTab;
